import { render } from "./AddShopMealPackDialog.vue?vue&type=template&id=2f7b1156&scoped=true&ts=true"
import script from "./AddShopMealPackDialog.vue?vue&type=script&lang=ts"
export * from "./AddShopMealPackDialog.vue?vue&type=script&lang=ts"

import "./AddShopMealPackDialog.vue?vue&type=style&index=0&id=2f7b1156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7b1156"]])

export default __exports__